import type { BlockError } from '@domain/schemas/block-error';
import type { ContractError } from '@domain/types/errors';
import { blockErrorMessages } from '@root/helpers/constants';
import { contractErrorMessages } from '@root/helpers/constants/contract-error-messages';

interface InvalidInfoProps {
  blockErrors?: BlockError[];
  contractErrors?: { type: ContractError; error: Record<string, string>[] }[];
}

export const InvalidInfo = ({ blockErrors, contractErrors }: InvalidInfoProps) => (
  <>
    {blockErrors?.map((error) => (
      <p key={error} className="text-info-400 mb-2 text-sm">
        {blockErrorMessages[error]}
      </p>
    ))}
    {contractErrors?.map((error) => (
      <p key={error.type} className="text-info-400 mb-2 text-sm">
        {contractErrorMessages[error.type]}
      </p>
    ))}
  </>
);
